export default __webpack_public_path__ + "static/media/rk10.9a792772.png";